import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RenderersModule } from 'src/app/shared/renderers/renderers.module';
import { SchedulingStatusFormComponent } from './scheduling-status-form/scheduling-status-form.component';
import { SchedulingStatusListComponent } from './scheduling-status-list/scheduling-status-list.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';


@NgModule({
  declarations: [
    SchedulingStatusListComponent,
    SchedulingStatusFormComponent
  ],
  imports: [
    CommonModule,
    RenderersModule,
    SharedModule,
    ReactiveFormsModule,
  ]
})
export class SchedulingStatusModule { }
